function mutationId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `synonym-review-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

const basePath = shopId => (
  `/system/shop/${encodeURIComponent(shopId)}/customization/search/synonym-suggestions`
);

/** Cloud adapter for the pluggable synonym-candidate inbox. */
export function createLegacySynonymSuggestionsApi({ client, mutationIdFactory = mutationId } = {}) {
  let resolvedClient = client || null;
  let pendingReview = null;
  const getClient = () => {
    if (!resolvedClient) {
      // eslint-disable-next-line global-require
      resolvedClient = require('util/appUtils').wsClient;
    }
    return resolvedClient;
  };

  return {
    async list(shopId, { status = 'pending', cursor = null, limit = 50 } = {}) {
      return getClient().prepareRequest('GET', basePath(shopId), {
        qs: { status, ...(cursor ? { cursor } : {}), limit },
      });
    },

    async ingest(shopId, candidates) {
      return getClient().prepareRequest('POST', `${basePath(shopId)}/ingest`, {
        body: { candidates },
      });
    },

    async review(shopId, decisions) {
      const signature = JSON.stringify(decisions);
      if (!pendingReview || pendingReview.signature !== signature) {
        pendingReview = { signature, id: mutationIdFactory() };
      }
      const result = await getClient().prepareRequest('POST', `${basePath(shopId)}/review`, {
        body: {
          decisions,
          client_mutation_id: pendingReview.id,
        },
      });
      pendingReview = null;
      return result;
    },
  };
}
